module.exports = __webpack_public_path__ + "img/linktwitter.d118de46.svg";